import { IRouteProps } from 'IRoute'

import permissions from '../../commons/constants/permissions'
import DashboardSla from '../../pages/DashboardSla'
import Home from '../../pages/Home'

const route:IRouteProps[] = [
  {
    path: '/',
    component: Home,
    roles: [permissions.HOME_ACCESS]
  },
  {
    path: '/sla',
    component: DashboardSla,
    roles: [permissions.SLA_ACCESS]
  }
]

export default route
